{
  "REPORT": {
    "HEADER": "Conversazioni",
    "LOADING_CHART": "Caricamento dati del grafico...",
    "NO_ENOUGH_DATA": "Non abbiamo ricevuto abbastanza punti dati per generare il rapporto, riprova più tardi.",
    "DOWNLOAD_AGENT_REPORTS": "Scarica rapporti agente",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversazioni",
        "DESC": "( Totale )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messaggi in arrivo",
        "DESC": "( Totale )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messaggi in uscita",
        "DESC": "( Totale )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tempo di prima risposta",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di prima risposta è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo di risoluzione",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di risoluzione è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Conteggio risoluzioni",
        "DESC": "( Totale )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Conteggio risoluzioni",
        "DESC": "( Totale )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Totale )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Oggi",
      "YESTERDAY": "Ieri",
      "LAST_7_DAYS": "Ultimi 7 giorni",
      "LAST_30_DAYS": "Ultimi 30 giorni",
      "THIS_MONTH": "Questo mese",
      "LAST_MONTH": "Mese scorso",
      "LAST_3_MONTHS": "Ultimi 3 mesi",
      "LAST_6_MONTHS": "Ultimi 6 mesi",
      "LAST_YEAR": "Ultimo anno",
      "CUSTOM_DATE_RANGE": "Intervallo di date personalizzato"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Applica",
      "PLACEHOLDER": "Seleziona intervallo di date"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Raggruppa per",
    "DURATION_FILTER_LABEL": "Durata",
    "GROUPING_OPTIONS": {
      "DAY": "Giorno",
      "WEEK": "Settimana",
      "MONTH": "Mese",
      "YEAR": "Anno"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Giorno"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Giorno"
      },
      {
        "id": 2,
        "groupBy": "Settimana"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Giorno"
      },
      {
        "id": 2,
        "groupBy": "Settimana"
      },
      {
        "id": 3,
        "groupBy": "Mese"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Giorno"
      },
      {
        "id": 2,
        "groupBy": "Settimana"
      },
      {
        "id": 3,
        "groupBy": "Mese"
      }
    ],
    "BUSINESS_HOURS": "Ore di lavoro",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nessun risultato trovato"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Conversazioni: {count}",
      "RESULT_COUNT_MESSAGE": "Messaggi: {count}",
      "EMPTY": "Nessun record trovato per questa barra.",
      "ERROR": "Impossibile caricare i record. Riprova.",
      "LOAD_MORE": "Carica altri",
      "PREVIOUS_BUCKET": "Barra precedente",
      "NEXT_BUCKET": "Barra successiva",
      "UNKNOWN_CONTACT": "Contatto sconosciuto",
      "UNKNOWN_INBOX": "Casella sconosciuta",
      "UNASSIGNED_AGENT": "Non assegnata",
      "NO_MESSAGE_CONTENT": "Messaggio senza contenuto",
      "MESSAGE_CREATED_AT": "Messaggio creato il {time}",
      "EVENT_OCCURRED_AT": "Evento avvenuto il {time}",
      "INCOMING_MESSAGE": "Messaggio in arrivo",
      "OUTGOING_MESSAGE": "Messaggio in uscita",
      "VIEW_ALL": "Visualizza nelle conversazioni",
      "VIEW_ALL_LIMIT": "Solo le barre con al massimo {limit} conversazioni si aprono nell'elenco delle conversazioni.",
      "HIDDEN_COUNT": "Non mostrati perché non sei membro della loro casella: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Panoramica degli agenti",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Caricamento dati del grafico...",
    "NO_ENOUGH_DATA": "Non abbiamo ricevuto abbastanza punti dati per generare il rapporto, riprova più tardi.",
    "DOWNLOAD_AGENT_REPORTS": "Scarica rapporti agente",
    "FILTER_DROPDOWN_LABEL": "Seleziona agente",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversazioni",
        "DESC": "( Totale )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messaggi in arrivo",
        "DESC": "( Totale )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messaggi in uscita",
        "DESC": "( Totale )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tempo di prima risposta",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di prima risposta è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo di risoluzione",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di risoluzione è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Conteggio risoluzioni",
        "DESC": "( Totale )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimi 7 giorni"
      },
      {
        "id": 1,
        "name": "Ultimi 30 giorni"
      },
      {
        "id": 2,
        "name": "Ultimi 3 mesi"
      },
      {
        "id": 3,
        "name": "Ultimi 6 mesi"
      },
      {
        "id": 4,
        "name": "Ultimo anno"
      },
      {
        "id": 5,
        "name": "Intervallo di date personalizzato"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Applica",
      "PLACEHOLDER": "Seleziona intervallo di date"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Panoramica etichette",
    "DESCRIPTION": "Monitora le prestazioni delle etichette con metriche chiave come conversazioni, tempi di risposta, tempi di risoluzione e casi risolti.",
    "LOADING_CHART": "Caricamento dati del grafico...",
    "NO_ENOUGH_DATA": "Non abbiamo ricevuto abbastanza punti dati per generare il rapporto, riprova più tardi.",
    "DOWNLOAD_LABEL_REPORTS": "Scarica report etichette",
    "FILTER_DROPDOWN_LABEL": "Seleziona etichetta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversazioni",
        "DESC": "( Totale )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messaggi in arrivo",
        "DESC": "( Totale )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messaggi in uscita",
        "DESC": "( Totale )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tempo di prima risposta",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di prima risposta è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo di risoluzione",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di risoluzione è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Conteggio risoluzioni",
        "DESC": "( Totale )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimi 7 giorni"
      },
      {
        "id": 1,
        "name": "Ultimi 30 giorni"
      },
      {
        "id": 2,
        "name": "Ultimi 3 mesi"
      },
      {
        "id": 3,
        "name": "Ultimi 6 mesi"
      },
      {
        "id": 4,
        "name": "Ultimo anno"
      },
      {
        "id": 5,
        "name": "Intervallo di date personalizzato"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Applica",
      "PLACEHOLDER": "Seleziona intervallo di date"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Panoramica casella",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Caricamento dati del grafico...",
    "NO_ENOUGH_DATA": "Non abbiamo ricevuto abbastanza punti dati per generare il rapporto, riprova più tardi.",
    "DOWNLOAD_INBOX_REPORTS": "Scarica report casella",
    "FILTER_DROPDOWN_LABEL": "Seleziona Casella",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversazioni",
        "DESC": "( Totale )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messaggi in arrivo",
        "DESC": "( Totale )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messaggi in uscita",
        "DESC": "( Totale )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tempo di prima risposta",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di prima risposta è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo di risoluzione",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di risoluzione è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Conteggio risoluzioni",
        "DESC": "( Totale )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimi 7 giorni"
      },
      {
        "id": 1,
        "name": "Ultimi 30 giorni"
      },
      {
        "id": 2,
        "name": "Ultimi 3 mesi"
      },
      {
        "id": 3,
        "name": "Ultimi 6 mesi"
      },
      {
        "id": 4,
        "name": "Ultimo anno"
      },
      {
        "id": 5,
        "name": "Intervallo di date personalizzato"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Applica",
      "PLACEHOLDER": "Seleziona intervallo di date"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Panoramica team",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Caricamento dati del grafico...",
    "NO_ENOUGH_DATA": "Non abbiamo ricevuto abbastanza punti dati per generare il rapporto, riprova più tardi.",
    "DOWNLOAD_TEAM_REPORTS": "Scarica report del team",
    "FILTER_DROPDOWN_LABEL": "Seleziona team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Conversazioni",
        "DESC": "( Totale )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Messaggi in arrivo",
        "DESC": "( Totale )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Messaggi in uscita",
        "DESC": "( Totale )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Tempo di prima risposta",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di prima risposta è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Tempo di risoluzione",
        "DESC": "( Media )",
        "INFO_TEXT": "Numero totale di conversazioni utilizzate per il calcolo:",
        "TOOLTIP_TEXT": "Il tempo di risoluzione è {metricValue} (basato su {conversationCount} conversazioni)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Conteggio risoluzioni",
        "DESC": "( Totale )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Ultimi 7 giorni"
      },
      {
        "id": 1,
        "name": "Ultimi 30 giorni"
      },
      {
        "id": 2,
        "name": "Ultimi 3 mesi"
      },
      {
        "id": 3,
        "name": "Ultimi 6 mesi"
      },
      {
        "id": 4,
        "name": "Ultimo anno"
      },
      {
        "id": 5,
        "name": "Intervallo di date personalizzato"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Applica",
      "PLACEHOLDER": "Seleziona intervallo di date"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Rapporti CSAT",
    "NO_RECORDS": "Non ci sono risposte al sondaggio CSAT disponibili.",
    "DOWNLOAD": "Scarica report CSAT",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Scegli agenti"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contatto",
        "AGENT_NAME": "Agente assegnato",
        "RATING": "Valutazione",
        "FEEDBACK_TEXT": "Commento del feedback"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Risposte totali",
        "TOOLTIP": "Numero totale di risposte raccolte"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Punteggio di soddisfazione",
        "TOOLTIP": "Numero totale di risposte positive / Numero totale di risposte * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Tasso di risposta",
        "TOOLTIP": "Numero totale di risposte / Numero totale di messaggi di sondaggio CSAT inviati * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Numero di conversazioni",
        "TOOLTIP": "Numero totale di conversazioni con messaggi del bot"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Numero di risposte",
        "TOOLTIP": "Numero totale di messaggi in uscita"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Numero di risposte AI",
        "TOOLTIP": "Numero totale di messaggi di risposta inviati dal bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Numero di risposte preparate",
        "TOOLTIP": "Numero totale di suggerimenti copilot preparati dal bot per gli agenti"
      },
      "SUCCESS_RATE": {
        "LABEL": "Risolte dall'AI",
        "TOOLTIP": "Percentuale di conversazioni risolte dall'AI senza passaggio ad agente"
      },
      "RESOLVE_TIME": {
        "LABEL": "Tempo di risoluzione",
        "TOOLTIP": "Tempo mediano dal primo messaggio del cliente all'ultimo messaggio del bot/agente"
      }
    },
    "GROUP_BY": {
      "LABEL": "Raggruppa per",
      "NONE": "Non raggruppare",
      "INBOXES": "Caselle",
      "LABELS": "Etichette"
    },
    "GROUPED": {
      "CHART_TITLE": "Distribuzione per gruppo",
      "BACK_TO_ALL": "Mostra tutto",
      "TABLE": {
        "INBOX": "Casella",
        "LABEL": "Etichetta",
        "CONVERSATIONS": "Conversazioni",
        "MESSAGES": "Messaggi",
        "MESSAGES_TOOLTIP": "Numero totale di messaggi in uscita",
        "AI_MESSAGES": "Risposte AI",
        "AI_MESSAGES_TOOLTIP": "Numero totale di risposte AI, seguito dal numero di valutazioni positive e negative degli utenti finali",
        "THUMBS_UP_TOOLTIP": "Numero di risposte AI valutate positivamente (pollice su) dagli utenti finali",
        "THUMBS_DOWN_TOOLTIP": "Numero di risposte AI valutate negativamente (pollice giù) dagli utenti finali",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Percentuale di risposte AI su tutti i messaggi di questo gruppo",
        "PREPARED": "Risposte preparate",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Percentuale di messaggi su tutti i messaggi appartenenti a questo gruppo",
        "BOT_RESPONSES": "Risposte AI %",
        "SUGGESTION_USED": "Risposte usate",
        "SUGGESTION_USED_TOOLTIP": "Percentuale di risposte preparate in questo gruppo che sono state usate dagli agenti",
        "SUGGESTION_NOT_USED": "Risposte non usate",
        "SUGGESTION_NOT_USED_TOOLTIP": "Percentuale di messaggi in questo gruppo che avevano una risposta preparata ma non è stata usata"
      },
      "NOTES": {
        "TITLE": "Come vengono calcolate le metriche",
        "CONVERSATIONS": "Numero di conversazioni che hanno almeno un messaggio in uscita nel periodo selezionato.",
        "MESSAGES": "Numero totale di messaggi (non privati) in uscita inviati nel periodo selezionato. Include sia messaggi generati dall'AI sia scritti da umani.",
        "PERCENTAGE": "Quota dei messaggi di questo gruppo su tutti i messaggi in uscita di tutti i gruppi.",
        "AI_MESSAGES": "Numero di messaggi in uscita inviati automaticamente dal bot AI (escluse le risposte preparate per gli agenti). I numeri tra parentesi mostrano quante di queste risposte sono state valutate positivamente (pollice su) e negativamente (pollice giù) dagli utenti finali.",
        "BOT_RESPONSES_PCT": "Quota delle risposte AI di questo gruppo su tutti i messaggi in uscita in questo gruppo.",
        "PREPARED": "Numero di suggerimenti copilot (risposte preparate) generati dal bot AI per gli agenti nel periodo selezionato. Sono messaggi privati visibili solo agli agenti e non vengono conteggiati come messaggi in uscita, quindi questo numero potrebbe non correlarsi con la colonna Messaggi.",
        "SUGGESTION_USED": "Percentuale di risposte preparate in questo gruppo che sono state usate dagli agenti. Potrebbe non correlarsi con il conteggio delle risposte preparate perché può includere anche suggerimenti generati in periodi precedenti.",
        "SUGGESTION_NOT_USED": "Percentuale di messaggi in uscita in questo gruppo in cui era disponibile un suggerimento copilot ma l'agente ha risposto senza usarlo. Conteggiata solo quando l'agente ha effettivamente inviato una risposta. Potrebbe non correlarsi con il conteggio delle risposte preparate perché può includere anche suggerimenti generati in periodi precedenti."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Panoramica",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Conversazioni aperte",
      "LOADING_MESSAGE": "Caricamento metriche conversazioni...",
      "OPEN": "Apri",
      "UNATTENDED": "Non partecipate",
      "UNASSIGNED": "Non assegnato",
      "PENDING": "In sospeso"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversazioni degli agenti",
      "LOADING_MESSAGE": "Caricamento metriche agenti...",
      "NO_AGENTS": "Non ci sono conversazioni da parte degli agenti",
      "TABLE_HEADER": {
        "AGENT": "Agente",
        "OPEN": "Apri",
        "UNATTENDED": "Non partecipate",
        "STATUS": "Stato"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Apri",
        "UNATTENDED": "Non partecipate",
        "STATUS": "Stato"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Stato agente",
      "ONLINE": "Online",
      "BUSY": "Occupato",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nessun risultato trovato",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Nome agente",
        "INBOXES": "Nome casella",
        "LABELS": "Nome etichetta",
        "TEAMS": "Nome del team"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Casella",
      "AGENTS": "Agente",
      "LABELS": "Etichetta",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversazioni",
        "AGENT": "Agente"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Subtotale",
    "NO_TEAM": "Nessun team",
    "GROUP_BY_TEAMS": "Raggruppa per team",
    "INBOX": "Casella",
    "AGENT": "Agente",
    "TEAM": "Team",
    "LABEL": "Etichetta",
    "TOTAL": "Totale",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Conteggio risoluzioni",
    "CONVERSATIONS": "Numero di conversazioni",
    "OUTGOING_CHATS": "Chat in uscita",
    "OUTGOING_EMAILS": "Email in uscita",
    "PHONE_CALLS": "Chiamate telefoniche",
    "INBOUND_CALLS": "Chiamate in entrata",
    "OUTBOUND_CALLS": "Chiamate in uscita",
    "TOTAL_ACTIVITIES": "Attività totali",
    "ONLINE_TIME": "Tempo online",
    "QUEUE_AVAILABLE_TIME": "Tempo disponibile in coda",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Numero di messaggi in uscita inviati da questo agente",
      "OUTGOING_EMAILS": "Numero di email in uscita inviate da questo agente",
      "PHONE_CALLS": "Numero totale di chiamate telefoniche assegnate a questo agente (somma di chiamate in entrata e in uscita)",
      "TOTAL_ACTIVITIES": "Numero totale di attività: chiamate in entrata + chiamate in uscita + chat in uscita + email in uscita",
      "INBOUND_CALLS": "Numero di chiamate telefoniche in entrata assegnate a questo agente",
      "OUTBOUND_CALLS": "Numero di chiamate telefoniche in uscita assegnate a questo agente",
      "AVG_FIRST_RESPONSE_TIME": "Tempo medio dalla creazione della conversazione alla prima risposta dell'agente nelle conversazioni assegnate a questo agente",
      "AVG_RESOLUTION_TIME": "Tempo medio dalla creazione della conversazione alla risoluzione nelle conversazioni assegnate a questo agente",
      "AVG_REPLY_TIME": "Tempo medio di attesa dei clienti tra il loro messaggio e la risposta dell'agente nelle conversazioni assegnate a questo agente",
      "ONLINE_TIME": "Tempo totale in cui l'agente è stato online o occupato durante il periodo selezionato",
      "QUEUE_AVAILABLE_TIME": "Tempo totale in cui l'agente è stato disponibile nelle code telefoniche durante il periodo selezionato"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Report telefonici",
    "DESCRIPTION": "Monitora le metriche delle chiamate telefoniche con dettagli su chiamate in entrata e in uscita, raggruppate per agente o casella per un'analisi completa.",
    "AGENT_HEADER": "Report telefonici - Per agente",
    "INBOX_HEADER": "Report telefonici - Per casella",
    "DOWNLOAD_BUTTON": "Scarica report telefonici",
    "DOWNLOAD_PHONE_REPORTS": "Scarica report telefonici",
    "GROUP_BY": {
      "LABEL": "Raggruppa per",
      "AGENT": "Agente",
      "INBOX": "Casella"
    },
    "TABLE": {
      "AGENT_NAME": "Nome agente",
      "INBOX_NAME": "Nome casella",
      "TOTAL_CALLS": "Totale",
      "INBOUND_CALLS": "In entrata",
      "OUTBOUND_CALLS": "In uscita",
      "FAILED_OUTBOUND_CALLS": "In uscita fallite",
      "AVG_AGENT_HANDLED_DURATION": "Durata media",
      "TOTAL_AGENT_HANDLED_DURATION": "Durata totale",
      "AVG_RINGING_TIME": "Tempo medio di squillo",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Successo %",
      "UNIQUE_CALLERS": "Chiamanti unici",
      "UNIQUE_CALLED_CONTACTS": "Chiamati unici",
      "UNANSWERED_MISSED_CALLS": "Perse senza follow-up",
      "UNANSWERED_MISSED_PERCENTAGE": "Perse senza risposta %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Perse senza follow-up, richiamate insufficienti",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Perse senza follow-up, richiamate insufficienti %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Numero totale di tutte le chiamate (incluse quelle non connesse)",
      "INBOUND_CALLS": "Numero di chiamate connesse",
      "OUTBOUND_CALLS": "Numero di tutte le chiamate in uscita (incluse quelle non connesse)",
      "FAILED_OUTBOUND_CALLS": "Numero di chiamate in uscita che non si sono connesse",
      "AVG_AGENT_HANDLED_DURATION": "Durata media delle chiamate gestite dagli agenti",
      "TOTAL_AGENT_HANDLED_DURATION": "Durata totale di tutte le chiamate gestite dagli agenti",
      "AVG_RINGING_TIME": "Tempo medio di squillo delle chiamate prima di essere risposte",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percentuale di chiamate in uscita connesse con successo",
      "UNIQUE_CALLERS": "Numero di contatti unici che hanno effettuato chiamate in entrata",
      "UNIQUE_CALLED_CONTACTS": "Numero di contatti unici chiamati tramite chiamate in uscita",
      "UNANSWERED_MISSED_CALLS": "Numero di chiamate perse per le quali non è stato effettuato un richiamo riuscito (chiamata connessa). Può includere chiamate ancora gestibili nella giornata lavorativa",
      "UNANSWERED_MISSED_PERCENTAGE": "Percentuale di chiamanti unici le cui chiamate sono state perse senza follow-up (chiamate perse senza risposta / chiamanti unici)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Numero di chiamate perse con meno di 2 tentativi di richiamata. Può includere chiamate ancora gestibili nella giornata lavorativa",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percentuale di chiamanti unici con meno di 2 tentativi di richiamata ((perse senza follow-up - gestite adeguatamente) / chiamanti unici)"
    },
    "EMPTY_STATE": {
      "TITLE": "Nessun dato sulle chiamate telefoniche disponibile",
      "MESSAGE": "Non ci sono chiamate telefoniche nell'intervallo di date selezionato. Prova a modificare i filtri o l'intervallo di date."
    }
  }
}
